module.exports = __webpack_public_path__ + "img/wave-2-gray-400.7084592.png";